import React from 'react';
import Component from '@vfuk/core-calendar-picker-with-label';
const CalendarPickerWithLabel = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default CalendarPickerWithLabel;
